export default {
  SERVICE_ID: `service_g1offqp`,
  TEMPLATE_ID: `Contact form forward`,
};
